/**
 * Group the 3 reports of a forecast together, namely, a P&L report
 * (aka. income statement), a balance sheet report and a cash flow
 * report.
 *
 * @param {Report[]} reports - The 3 reports
 */
export default class ReportManager {
	constructor({ incomeStatement, balanceSheet, cashFlow }) {
		this._incomeStatement = incomeStatement;
		this._balanceSheet = balanceSheet;
		this._cashFlow = cashFlow;
	}

	getReportsAsList() {
		return [
			this._incomeStatement,
			this._balanceSheet,
			this._cashFlow,
		].filter(Boolean);
	}

	getReports() {
		return {
			incomeStatement: this._incomeStatement,
			balanceSheet: this._balanceSheet,
			cashFlow: this._cashFlow,
		};
	}

	getReportFromId(reportId) {
		return this.getReportsAsList().find(
			(report) => report.getId() === reportId,
		);
	}

	getRowByStableId(rowId) {
		return this._retrieve((report) => report.getRowByStableId(rowId));
	}

	getRowForAccountNumber(accountNumber) {
		return this._retrieve((report) =>
			report.getVisibleRowForAccountNumber(accountNumber),
		);
	}

	getIncomeStatement() {
		return this._incomeStatement;
	}

	getBalanceSheet() {
		return this._balanceSheet;
	}

	getCashFlow() {
		return this._cashFlow;
	}

	_retrieve(fn = (_report) => {}) {
		for (const report of this.getReportsAsList()) {
			const item = fn(report);
			if (item) return item;
		}

		return undefined;
	}
}
